import { useEffect, useState } from "react";

const LINKS = [
  { label: "About", href: "#about" },
  { label: "Services", href: "#services" },
  { label: "Festival", href: "#event" },
  { label: "Portfolio", href: "#portfolio" },
  { label: "Contact", href: "#contact" },
];

const Logo = () => (
  <a href="#top" data-testid="nav-logo" className="flex items-baseline gap-[2px] group">
    <span className="font-heading text-2xl tracking-tight text-foreground">9ja</span>
    <span className="font-heading text-2xl tracking-tight text-gold">clicks</span>
    <span className="ml-1 h-1 w-1 rounded-full bg-gold transition-transform duration-500 group-hover:scale-150" />
  </a>
);

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? "backdrop-blur-xl bg-background/70 border-b border-white/10 py-4" : "bg-transparent py-6"
      }`}
    >
      <nav className="mx-auto max-w-7xl px-6 lg:px-10 flex items-center justify-between">
        <Logo />

        <div className="hidden md:flex items-center gap-10">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-${l.label.toLowerCase()}-link`}
              className="text-sm tracking-wide text-foreground/70 hover:text-gold transition-colors duration-300"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#contact"
            data-testid="nav-book-button"
            className="border border-gold/60 text-gold px-6 py-2.5 text-xs uppercase tracking-[0.2em] hover:bg-gold hover:text-primary-foreground transition-all duration-500"
          >
            Book Consultation
          </a>
        </div>

        <button
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen((o) => !o)}
          className="md:hidden flex flex-col gap-1.5 p-2"
          aria-label="Toggle menu"
        >
          <span className={`h-px w-6 bg-foreground transition-all ${open ? "rotate-45 translate-y-2" : ""}`} />
          <span className={`h-px w-6 bg-foreground transition-all ${open ? "opacity-0" : ""}`} />
          <span className={`h-px w-6 bg-foreground transition-all ${open ? "-rotate-45 -translate-y-2" : ""}`} />
        </button>
      </nav>

      {open && (
        <div data-testid="mobile-menu" className="md:hidden mt-4 mx-6 border-t border-white/10 pt-4 flex flex-col gap-4 pb-2">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              data-testid={`mobile-nav-${l.label.toLowerCase()}-link`}
              className="text-sm tracking-wide text-foreground/80 hover:text-gold transition-colors"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#contact"
            onClick={() => setOpen(false)}
            data-testid="mobile-nav-book-button"
            className="border border-gold/60 text-gold px-6 py-2.5 text-xs uppercase tracking-[0.2em] text-center hover:bg-gold hover:text-primary-foreground transition-all"
          >
            Book Consultation
          </a>
        </div>
      )}
    </header>
  );
}
